import React, { useEffect, useMemo, useRef, useState } from 'react';
import { webLoadingFalse, webLoadingTrue, webNavigate } from '../../services/navigate.service';
import SearchIcon from '../../images/SearchIcon';
import { ProductOrderTemplateResponse, } from '../OrderTemplates/OrderTemplatesDetail';
import PlusIcon from '../../images/PlusIcon';
import CloseIcon from '../../images/CloseIcon';
import WhiteCheckIcon from '../../images/WhiteCheckIcon';
import {
    OrderDetailResponse,
    updateOrders,
} from '../../services/order.service';
import { getListProductWithOrderTemplate, getListProductWithSupplierReturn } from '../../services/items.services';
import { useInfiniteScroll } from '../../hook/useInfiniteScroll';
import { validateDecimalNumer, validateOnlyNumbersExpand } from '../../validation/ValidationInput';
import PopupConfirm from '../../components/PopupConfirm';
import { showToast } from '../../services/toast.service';
import { showApiError } from '../../services/apiError';
import PopupLocation from '../../components/PopupLocation';
import { createPartialDeliveries } from '../../services/deleveries.service';
import ProductSelectionSupplierModal from '../../components/ProductSelectionSupplierModal';
import { createSupplierReturn, SupplierReturnDetail, SupplierReturnPayload, updateSupplierReturn } from '../../services/supplierReturn.service';
import BackIcon from '../../images/BackIcon';
import { getDetailSupplierReturn } from '../../services/supplier.service';
import { DropdownSearch } from '../../components/DropdownSearch';
import PlusGreenIcon from '../../images/PlusGreenIcon';
import DropdownIcon from '../../images/DropdownIcon';
import { useResponsive } from '../../hook/useResponsive';

interface OrderDetail {
    productId: string;
    orderQty: number;
    deliveryQty: number;
    varianceQty: number;
    cost: number;
    lineCost: number;
    taxId: string;
}

interface OrderPayload {
    clientId: string;
    internalNumber: number;
    comment: string;
    companyId: string;
    locationId: string;
    statusId: number;
    amount: number;
    delivery: number;
    tax: number;
    orderTemplateId: string;
    supplierReturnDetails: OrderDetail[];
}

export interface ProductWithStock {
    id: string;
    productId: string;
    isAttributes: boolean;
    uomName: string;
    lowQty: number,
    medQty: number,
    highQty: number,
    product: {
        sku: string;
        type: number;
        productName: string;
        productGroup: { groupName: string };
        UOM: { uomName: string };
        productPrices: [{ cost: string }];
        inventoryValuation: { unitCost: string };
        updatedAt: Date;
        isActive: boolean;
        isAttributes: true | false;
    }
    currentStock: number;
}

const SupplierReturnDetails = () => {
    const preLanguage = localStorage.getItem('language');
    const companyId = localStorage.getItem('companyId') || '';
    const [language, setLanguage] = useState<any>(null);
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [showPopupReturn, setShowPopupReturn] = useState<boolean>(false);
    const path = window.location.pathname;
    const id: string = path.split('/').pop() || '';
    const listStatus = [
        { id: 1, name: 'Draft', value: 1 },
        { id: 2, name: 'Dispatched', value: 2 },
        { id: 3, name: 'Credited', value: 3 },
        { id: 4, name: 'Cancelled', value: 4 },
    ]
    const dropdownUOMRef = useRef<HTMLDivElement>(null);
    const statusRef = useRef<HTMLDivElement>(null);
    const searchInpuGlobaltRef = useRef<HTMLInputElement | null>(null);
    const [formValues, setFormValues] = useState<any>(null);
    const [listProductsReturn, setListProductsReturn] = useState<any[]>([]);
    // Rows ticked in the open picker that are not lines yet; line unticks live on the line's checkProduct.
    const [listProductsSelectReturn, setListProductsSelectReturn] = useState<any[]>([]);
    const [listRawProducts, setListRawProducts] = useState<OrderDetailResponse[]>([]);
    const [lineSearch, setLineSearch] = useState<string>('');
    const [status, setStatus] = useState<any>()
    const [popupDesc, setPopupDesc] = useState<string>("");
    const [hasMore, setHasMore] = useState({
        product: true,
        productReturn: true
    });
    const [loading, setLoading] = useState({
        product: true,
        productReturn: true
    });
    const scrollRefReturn = useRef<HTMLDivElement | null>(null);
    const hasLoadedPageRef = useRef(new Set<number>());
    const hasLoadedPageReturnRef = useRef(new Set<number>());
    const PAGE_SIZE = 30;
    const initalFilter = {
        searchValue: '',
        page: 1,
        searchValueProduct: '',
        initLoad: false
    };
    const [filter, setFilter] = useState<any>(initalFilter);
    const [filterReturn, setFilterReturn] = useState<any>(initalFilter);
    const numberOfKeys = [
        'SKU',
        'Group',
        'Product',
        'UOM',
        'Cost',
        'Delivered',
        'Return Qty',
        'Line Cost',
    ];
    const [isUOMDropdownOpen, setIsUOMDropdownOpen] = useState<{
        [key: string]: boolean;
    }>({});
    const { isMobile, getWidth } = useResponsive();
    const [listUOM, setListUOM] = useState<any>([]);
    const [searchUOM, setSearchUOM] = useState<any>();
    const [productDataCache, setProductDataCache] = useState<Record<string, any>>({});
    const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (statusRef.current && !statusRef.current.contains(event.target as Node)) {
                setIsStatusDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.addEventListener('mousedown', handleClickOutside);
    }, []);
    const handleStatusSelect = (status: { name: string; value: number }) => {
        setStatus(status.name);
        setIsStatusDropdownOpen(false);
    };
    const handleUOMSelect = (uom: any, productId: string) => {
        const productSelect: any = formValues?.supplierReturnDetails.find((v: any) => v.productId === productId);
        let uomSelect: any;
        if (productSelect) {
            uomSelect = productSelect?.product?.productUOMs.find((v: any) => v?.id === uom?.id);
        }
        setSearchUOM((prev: any) => ({
            ...prev,
            [productId]: uomSelect?.uom?.uomName || uom.uomName,
        }));
        setIsUOMDropdownOpen((prev) => ({ ...prev, [productId]: false }));
        setFormValues((prev: any) => {
            const newList = prev.supplierReturnDetails.map((item: any) => {
                if (item.productId !== productId) return item;
                const unitCost = item.unitCost
                    ? Number(item.unitCost)
                    : Number((Number(item.cost) / Number(item.conversionFactorUsed)).toFixed(2));

                const conversionFactor = Number(uomSelect?.uom?.conversionFactor ?? item?.conversionFactor);
                const qtyReturned = Number(item.qtyReturned ?? 0);
                const cost = Number((conversionFactor * unitCost).toFixed(2));
                const lineCost = Number((conversionFactor * unitCost * qtyReturned).toFixed(2));
                return {
                    ...item,
                    conversionFactorUsed: conversionFactor,
                    productUOMId: uomSelect?.id ?? item.productUOMId,
                    unitCost: unitCost,
                    cost: cost,
                    lineCost: lineCost,
                };
            });
            return {
                ...prev,
                supplierReturnDetails: newList,
            };
        });
    };
    const handleSearchUOM = (value: string, index: number) => {
    };
    useEffect(() => {
        if (window.languageContext) {
            setLanguage(window.languageContext.language);
        }
    }, [window, window.languageContext]);
    const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const handleKeyDown = (event: KeyboardEvent) => {
        if ((event.ctrlKey || event.metaKey) && event.key === 'f') {
            event.preventDefault();
            if (searchInpuGlobaltRef.current) {
                searchInpuGlobaltRef.current.focus();
            }
        }
    };
    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);


    const handleFormatData = (type: number) => {
        const supplierReturnDetails = (formValues?.supplierReturnDetails ?? []).filter(
            (item: any) => Number(item.orderQty) > 0
        );
        const totalLineCost = supplierReturnDetails.reduce(
            (acc: number, item: any) => acc + Number(item.lineCost ?? 0),
            0
        );
        const totalDeliveryQty = supplierReturnDetails.reduce(
            (acc: number, item: any) => acc + Number(item.deliveryQty ?? 0),
            0
        );
        const totalTax = (() => {
            const withoutTaxSum = supplierReturnDetails.reduce((acc: number, item: any) => {
                const taxRate =
                    Number(item?.product?.productPrices?.[0]?.tax?.primaryRate ?? 0);
                const priceExclTax =
                    Number(item.lineCost ?? 0) / (1 + taxRate / 100);
                return acc + priceExclTax;
            }, 0);

            return Number((totalLineCost - withoutTaxSum).toFixed(2));
        })();

        const payload: OrderPayload = {
            clientId: formValues?.clientId || "",
            internalNumber: formValues?.internalNumber || 0,
            companyId: companyId,
            comment: formValues?.comment || "",
            locationId: localStorage.getItem("locationId") || "",
            statusId: type,
            amount: totalLineCost,
            delivery: totalDeliveryQty,
            tax: totalTax,
            orderTemplateId: formValues?.orderTemplateId || "",
            supplierReturnDetails: supplierReturnDetails.map((item: any) => {
                const conversion = Number(item.conversionFactorUsed ?? 0);
                const costPerUOM = conversion * Number(item.cost ?? 0);
                const orderQty = Number(item.orderQty ?? 0);
                return {
                    productId: item.productId,
                    orderQty,
                    deliveryQty: Number(item.deliveryQty ?? 0),
                    varianceQty: Number(item.varianceQty ?? 0),
                    cost: Number(item.cost ?? 0),
                    lineCost: costPerUOM * orderQty,
                    taxId: item.taxId || "",
                    conversionFactorUsed: conversion,
                    productUOMId: item.productUOMId || "",
                };
            }),
        };
        return payload
    }


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const payload: SupplierReturnPayload = {
            locationId: formValues?.locationId ?? '',
            supplierId: formValues?.supplierId ?? '',
            orderId: formValues?.orderId ?? '',
            statusId: listStatus.find((v) => v.name === status)?.value || 1,
            reason: "",
            supplierReturnDetails: formValues?.supplierReturnDetails
                .map((item: any): SupplierReturnDetail => {
                    return {
                        productId: item.productId,
                        originalOrderDetailId: item.originalOrderDetailId,
                        qtyReturned: Number(item.qtyReturned) || 0,
                        unitCost: Number(item.unitCost ) || 0,
                        lineCost: Number(item.unitCost) * Number(item.conversionFactorUsed ?? 1) * Number(item.qtyReturned) || 0,
                        taxRateId: item?.product?.productPrices[0] ? item?.product?.productPrices[0]?.tax?.id : item?.productPrices[0]?.tax?.id ?? "",
                        productUOMId: item.productUOMId,
                    };
                }),
        };
        webLoadingTrue();
        try {
            const response: any = await updateSupplierReturn(payload, id);
            if (response) {
                webNavigate("/" + preLanguage + "/supplierReturn");
                webLoadingFalse();
                showToast({
                    message: language?.['Delivery Updated !'] ?? 'Delivery Updated !',
                    type: 'success',
                    duration: 20000,
                });
            }
        } catch (error: any) {
            webLoadingFalse();
            webNavigate("/" + preLanguage + "/supplierReturn");
            showApiError(error, { language });
        }
    };


    // Ticked = lines not unticked in this session + explicit ticks, keyed by product id.
    const isPickedReturn = (productId: string) =>
        (formValues?.supplierReturnDetails ?? []).some((v: any) => v.productId === productId && v.checkProduct !== false)
        || listProductsSelectReturn.some((p: any) => p.productId === productId);

    const fetchAndAppendProductListReturn = async (
        filterReturn: any,
        id: string,
        PAGE_SIZE: number,
        isAppend: boolean = true,
        orderId: any
    ) => {
        try {
            setLoading(prev => ({ ...prev, productReturn: true }));

            const response: any = await getListProductWithSupplierReturn(
                filterReturn.page,
                PAGE_SIZE,
                filterReturn.searchValue,
                id,
                orderId
            );
            const fetchedProducts: any = response.data.data.data;
            // Ticks mirror the current lines (unsaved adds/removals too); the API only knows saved ones.
            const updatedProducts: any[] = fetchedProducts.map((value: any) => ({
                ...value,
                checkProduct: formValues ? isPickedReturn(value?.product.id) : value?.checkProduct,
                productId: value?.product.id,
                groupName: value?.product.productGroup.groupName,
                productName: value?.product.productName,
                sku: value?.product.sku,
                uomName: value?.product.productUOMs.find((v: any) => v.isBase)?.uom.uomName || '',
                productUOMs: value?.product?.productUOMs,
                productUOMId: value?.productUOMId,
                cost: value?.cost,
                lineCost: value?.lineCost,
                productPrices: value?.product?.productPrices,
                originalOrderDetailId: value?.id
            }));

            if (isAppend) {
                setListProductsReturn(prev => [...prev, ...updatedProducts]);
            } else {
                setListProductsReturn(updatedProducts);
            }

            setFilterReturn((prev: any) => ({
                ...prev,
                page: filterReturn.page + 1,
                searchValue: filterReturn.searchValue,
            }));

            if (fetchedProducts.length < PAGE_SIZE) {
                setHasMore(prev => ({ ...prev, productReturn: false }));
            } else {
                setHasMore(prev => ({ ...prev, productReturn: true }));
            }
        } catch (err) {
            console.error('Error fetching product list:', err);
            hasLoadedPageReturnRef.current.delete(filterReturn.page);
        } finally {
            setLoading(prev => ({ ...prev, productReturn: false }));
        }
    };


    const handleChangeDetailProduct = (index: number, event: any, type: 'qtyReturned') => {
        const value = event.target.value;
        const tempArray = [...(formValues?.supplierReturnDetails || [])];
        tempArray[index] = { ...tempArray[index], [type]: value };
        setFormValues((prev: any) => (prev ? { ...prev, supplierReturnDetails: tempArray } : null));
    };

    const handleBlurDetailProduct = (index: number, event: any, type: 'qtyReturned') => {
        const tempArray = [...(formValues?.supplierReturnDetails || [])];
        const cost = +(tempArray[index]?.cost || 0);
        const qtyReturned = +(tempArray[index]?.qtyReturned || 0);
        tempArray[index] = {
            ...tempArray[index],
            cost: cost,
            qtyReturned: qtyReturned,
            lineCost: cost * qtyReturned,
        };
        setFormValues((prev: any) => (prev ? { ...prev, supplierReturnDetails: tempArray } : null));
    };

    const onLoadMoreReturn = async (orderId: any) => {
        if (hasLoadedPageReturnRef.current.has(filterReturn.page)) return;
        hasLoadedPageReturnRef.current.add(filterReturn.page);
        setLoading(prev => ({ ...prev, productReturn: true }));
        await fetchAndAppendProductListReturn(
            filterReturn,
            id,
            PAGE_SIZE,
            true,
            // The scroll loader calls this without an argument.
            orderId ?? formValues?.orderId
        );
    };

    const { setLoaderRef: setLoaderRefReturn } = useInfiniteScroll({
        hasMore: hasMore.productReturn,
        loading: loading.productReturn,
        onLoadMore: onLoadMoreReturn,
        scrollRootRef: scrollRefReturn,
    });

    const searchUOMReturnForModal = useMemo(() => {
        const newSearchUOM: Record<string, string> = {};
        listProductsReturn.forEach((item: any) => {
            const selectedUOM = item.productUOMs?.find(
                (u: any) => u.id === item.productUOMId
            );
            if (selectedUOM?.uom?.uomName) {
                newSearchUOM[item.productId] = selectedUOM.uom.uomName;
            }
        });
        return newSearchUOM;
    }, [listProductsReturn]);

    const fetchData = async (id: string) => {
        webLoadingTrue();
        try {
            const response: any = await getDetailSupplierReturn(id);
            onLoadMoreReturn(response?.data?.data?.orderId);
            setStatus(listStatus.find((v) => v.value === response?.data?.data.statusId)?.name ?? '');
            const processedDetails = response.data.data.supplierReturnDetails.map((item: any) => {
                const uomSelect = item.product?.productUOMs?.find(
                    (u: any) => u.UOMId === item.uomId
                );
                const conversion = Number(uomSelect?.uom.conversionFactor ?? 1);
                const originalOrderQty = Number(item.orderQty ?? 0);
                const unitCost = item?.unitCost;
                const uomName = uomSelect?.uom?.uomName ?? "/";

                setSearchUOM((prev: any) => ({
                    ...prev,
                    [item.productId]: uomName
                }));
                const partialQty = item?.partialDeliveriesDetails?.length > 0
                    ? item.partialDeliveriesDetails.reduce(
                        (acc: number, val: any) => acc + (Number(val?.deliveryQty) || 0),
                        0
                    )
                    : 0;
                const cost = unitCost * conversion;
                const lineCost = unitCost * conversion * Number(item?.qtyReturned);
                return {
                    ...item,
                    inTemplate: true,
                    delivered: Number(item?.orderDetail?.orderQty),
                    qtyReturned: Number(item?.qtyReturned),
                    uomName,
                    cost,
                    unitCost,
                    lineCost,
                    expectedQty: originalOrderQty,
                    ...(partialQty > 0 && { partialQty }),
                };
            });
            setFormValues({
                ...response.data.data,
                supplierReturnDetails: processedDetails,
            });
            setListRawProducts(response.data.data.supplierReturnDetails.map((item: any) => {
                const orderQty = Number(item.orderQty ?? 0);
                const cost = Number(item.cost ?? 0);
                const conversion = Number(item.conversionFactorUsed ?? 0);
                const unitCost = Number(item.cost ?? 0) / Number(item.conversionFactorUsed ?? 0);
                const uomSelect = item.product?.productUOMs?.find(
                    (u: any) => u.id === item.uomId
                );
                return {
                    ...item,
                    inTemplate: true,
                    uomName: uomSelect?.uom?.uomName ?? "/",
                    cost: unitCost * conversion,
                    unitCost: unitCost,
                    lineCost: orderQty * cost,
                    ...(item?.partialDeliveriesDetails?.length > 0
                        ? {
                            partialQty: item?.partialDeliveriesDetails.reduce(
                                (acc: number, val: any) => acc + (Number(val?.deliveryQty) || 0),
                                0
                            ),
                            expectedQty: item?.orderQty,
                            orderQty: item?.orderQty - item?.partialDeliveriesDetails.reduce(
                                (acc: number, val: any) => acc + (Number(val?.deliveryQty) || 0),
                                0
                            ),
                        }
                        : { expectedQty: item?.orderQty }),
                };
            }));
            return response.data.data.supplierReturnDetails;
        } catch (error) {
            console.error('Error loading terms:', error);
        } finally {
            webLoadingFalse();
        }
    };
    useEffect(() => {
        fetchData(id);
        const handleNewToken = () => {
            fetchData(id);
            // if (id === "new") {
            //     await fetchProducts('');
            // }
        };
        document.addEventListener('newToken', handleNewToken);
        return () => {
            document.removeEventListener('newToken', handleNewToken);
        };
    }, [path]);
    // The search only hides rows; formValues.supplierReturnDetails keeps every line for the payload.
    const handleSubmitSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            setLineSearch(filter.searchValue?.trim().toLowerCase() ?? '');
        }
    };
    const matchesLineSearch = (line: any) =>
        !lineSearch || !!line?.product?.productName?.toLowerCase().includes(lineSearch);

    // Keyed by product id, so a tick survives paging and searches; nothing changes the lines until Save.
    const handleSelectProductReturn = (value: any) => {
        const checked = !value.checkProduct;
        const isLine = (formValues?.supplierReturnDetails ?? []).some((p: any) => p.productId === value.productId);
        if (isLine) {
            setFormValues((prev: any) => ({
                ...prev,
                supplierReturnDetails: prev.supplierReturnDetails.map((p: any) =>
                    p.productId === value.productId ? { ...p, checkProduct: checked } : p
                ),
            }));
        } else {
            setListProductsSelectReturn(prev => [
                ...prev.filter((p: any) => p.productId !== value.productId),
                ...(checked ? [{ ...value, checkProduct: true }] : []),
            ]);
        }
        setListProductsReturn(prev => prev.map((product: any) =>
            product.productId === value.productId ? { ...product, checkProduct: checked } : product
        ));
    };

    const handleSelectUOM = (value: any) => {
        setListProductsReturn(value);
        // An explicit tick keeps the UOM picked on its row, which Save then uses.
        setListProductsSelectReturn(prev => prev.map((p: any) => {
            const row = value.find((v: any) => v.productId === p.productId);
            return row ? { ...row, checkProduct: true } : p;
        }));
    };


    // Discard the session: line unticks back to ticked, and no new row is added later.
    const handleCancelAddProductReturn = () => {
        const lineIds = new Set((formValues?.supplierReturnDetails ?? []).map((v: any) => v.productId));
        setFormValues((prev: any) => (prev ? { ...prev, supplierReturnDetails: prev.supplierReturnDetails.map((p: any) => ({ ...p, checkProduct: true })) } : prev));
        setListProductsSelectReturn([]);
        setListProductsReturn(prev => prev.map((p: any) => ({ ...p, checkProduct: lineIds.has(p.productId) })));
        setShowPopupReturn(false);
    }


    const handleAddProductReturn = async (listProducts: any) => {
        // Kept lines = lines still ticked; new lines = explicit ticks of products that are not lines.
        const addedRows = listProductsSelectReturn;

        setFormValues((prev: any) => {
            setProductDataCache((prevCache: any) => {
                const newCache = { ...prevCache };

                (prev.supplierReturnDetails || []).forEach((item: any) => {
                    newCache[item.productId] = item;
                });

                return newCache;
            });

            const lines = prev.supplierReturnDetails || [];
            const updatedDetails: any[] = lines.filter((p: any) => p.checkProduct !== false);

            addedRows.forEach((item: any) => {
                if (!lines.some((p: any) => p.productId === item.productId)) {
                    const cachedData = productDataCache[item.productId];

                    if (cachedData) {
                        updatedDetails.push({ ...cachedData, checkProduct: true });
                    } else {
                        updatedDetails.push({
                            ...item,
                            delivered: Number(item.deliveryQty ?? 0),
                            qtyReturned: 0,
                            cost: item.cost || 0,
                            lineCost: 0,
                            unitCost: Number(item.cost) / Number(item.conversionFactorUsed) || 0,
                            conversionFactorUsed: Number(item.conversionFactorUsed) || 1,
                        });
                    }
                }
            });

            setSearchUOM((prevUOM: any) => {
                const newUOM = { ...prevUOM };

                updatedDetails.forEach((product: any) => {
                    if (!newUOM[product.productId]) {
                        newUOM[product.productId] = product.uomName || '/';
                    }
                });

                return newUOM;
            });

            return {
                ...prev,
                supplierReturnDetails: updatedDetails
            };
        });

        setListProductsSelectReturn([]);
        // Clear the line search so a just-added line is not hidden yet still saved.
        setLineSearch('');
        setFilter((prev: any) => ({ ...prev, searchValue: '' }));
        setShowPopupReturn(false);
    };

    // A search starts at page 1 of its term; scroll paging then resumes at page 2 of the same term.
    const loadDataProduct = async (filter: any) => {
        try {
            setLoading(prev => ({ ...prev, productReturn: true }));
            const response: any = await getListProductWithSupplierReturn(
                1,
                PAGE_SIZE,
                filter.searchValue,
                id,
                formValues?.order?.id
            );
            const fetchedProducts: any = response.data.data.data;
            // Ticks mirror the current lines (unsaved adds/removals too); the API only knows saved ones.
            const updatedProducts: any[] = fetchedProducts.map((value: any) => ({
                ...value,
                checkProduct: formValues ? isPickedReturn(value?.product.id) : value?.checkProduct,
                productId: value?.product.id,
                groupName: value?.product.productGroup.groupName,
                productName: value?.product.productName,
                sku: value?.product.sku,
                uomName: value?.product.productUOMs.find((v: any) => v.isBase)?.uom.uomName || '',
                productUOMs: value?.product?.productUOMs,
                productUOMId: value?.productUOMId,
                cost: value?.cost,
                lineCost: value?.lineCost,
                productPrices: value?.product?.productPrices,
                originalOrderDetailId: value?.id
            }));
            setListProductsReturn(updatedProducts)
            hasLoadedPageReturnRef.current = new Set([1]);
            setFilterReturn((prev: any) => ({ ...prev, page: 2, searchValue: filter.searchValue }));
            setHasMore(prev => ({ ...prev, productReturn: fetchedProducts.length >= PAGE_SIZE }));
        } catch (err) {
            console.error('Error fetching product list:', err);
        } finally {
            setLoading(prev => ({ ...prev, productReturn: false }));
        }
    };

    // The picker search lives in filterReturn; the main filter belongs to the line search.
    const handleSubmitSearchProductReturn = async (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            loadDataProduct({ searchValue: filterReturn.searchValue, page: 1 });
        }
    };
    const handleClosePopup = () => {
        setShowPopup(false);
    };
    const handleOpenPopup = () => {
        setShowPopup(true);
    };

    return (
        <>
            <div className="bg-white">
                <div className="flex items-center ">
                    <div
                        className="w-6 h-6 flex items-center justify-center cursor-pointer"
                        onClick={() => {
                            webNavigate('/' + preLanguage + '/supplierReturn');
                        }}
                    >
                        <BackIcon />
                    </div>
                    <p
                        style={{ fontSize: '14px', fontWeight: '500', lineHeight: '28px', color: '#222525' }}
                        className="font-inter"
                    >
                        {language && language?.['Back'] ? language?.['Back'] : 'Back'}
                    </p>
                </div>
            </div>
            {id === 'new' ? (
                <p
                    style={{
                        margin: '20px 0px',
                        fontSize: '20px',
                        fontWeight: '500',
                        lineHeight: '28px',
                        color: '#222525',
                    }}
                    className="font-inter"
                >
                    {language && language?.['Add supplier return']
                        ? language?.['Add supplier return']
                        : 'Add supplier return'}
                </p>
            ) : (
                <div className="lg:flex items-center justify-between" style={{ height: isMobile ? '' : "40px" }}>
                    <p
                        style={{
                            margin: '20px 0px',
                            fontSize: '20px',
                            fontWeight: '500',
                            lineHeight: '28px',
                            color: '#222525',
                        }}
                        className="font-inter"
                    >
                        {language && language?.[' Edit supplier return']
                            ? language?.['Edit supplier return']
                            : 'Edit supplier return'}
                    </p>
                    <div className='w-full h-full relative' style={{ width: isMobile ? '100%' : '160px' }}>
                        <DropdownSearch<{ value: number; name: string }>
                            refKey="type"
                            refs={{ type: statusRef }}
                            openStates={{ type: isStatusDropdownOpen }}
                            open={(key) => key === "type" && setIsStatusDropdownOpen(true)}
                            close={(key) => key === "type" && setIsStatusDropdownOpen(false)}
                            data={listStatus}
                            labelExtractor={(item) => item.name}
                            value={status}
                            setValue={setStatus}
                            onSelect={handleStatusSelect}
                            tabIndex={2}
                            borderNone={false}
                        />
                    </div>
                </div>
            )}

            <div className='scroll-container' style={{ height: isMobile ? 'calc(100% - 210px)' : 'calc(100% - 125px)', overflowY: 'scroll' }}>
                {/* Detail Section */}
                <div className="" style={{ marginTop: '16px', padding: '24px', backgroundColor: '#F8F8F8', border: "1px solid #EBF0F0", borderRadius: '16px' }}>
                    <div className="lg:flex items-center justify-between" style={{ gap: isMobile ? '' : '48px' }}>
                        <div className="space-y-2" style={{ width: isMobile ? '100%' : '48%' }}>
                            <p className="text-[14px] font-medium font-inter text-[#000000]">
                                Order number: #{formValues?.order?.internalNumber}
                            </p>
                            <p className="text-[14px] font-medium font-inter text-[#000000]">Supplier: {formValues?.supplier?.companyName}</p>
                            <p className="text-[14px] font-medium font-inter text-[#000000]">
                                Location: {formValues?.location?.name}
                            </p>
                            <p className="text-[14px] font-medium font-inter text-[#000000]">
                                Order Date: {formatDate(formValues?.createdAt)}
                            </p>
                        </div>
                        {
                            isMobile ?
                                <div style={{ height: '1px', width: '100%', backgroundColor: '#DBE4E4', margin: '20px 0' }}></div>
                                :
                                <div style={{ height: '100%', width: '1px', backgroundColor: '#DBE4E4' }}></div>
                        }
                        <div className="space-y-2" style={{ width: isMobile ? '100%' : '48%' }}>
                            <p className="text-[14px] font-medium font-inter text-[#000000]">Ordered By: {formValues?.order?.createdBy?.firstName ? formValues?.order?.createdBy?.lastName : '/'}</p>
                            <p className="text-[14px] font-medium font-inter text-[#000000]">
                                Approved By: {formValues?.approvedName ?? '/'}
                            </p>
                            <p className="text-[14px] font-medium font-inter text-[#000000]">Approval Date: {formatDate(formValues?.order?.approvalDate)}</p>
                            <p className="text-[14px] font-medium font-inter text-[#000000]">
                                Order Template: {formValues?.order?.orderTemplate?.templateName ?? '/'}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Filter Section */}
                <div className="py-4" >
                    <div className="flex justify-end w-full gap-x-2">
                        <div className="relative w-[400px]">
                            <input
                                ref={searchInpuGlobaltRef}
                                style={{ border: '1px solid #C9D7D8', padding: '8px 36px', minWidth: '350px', height: '40px', color: '#05292A', borderRadius: '12px' }}
                                name="searchValue"
                                onKeyDown={handleSubmitSearch}
                                value={filter.searchValue}
                                onChange={(e: any) => { setFilter({ ...filter, searchValue: e.target.value }) }}
                                className="font-inter placeholder:text-placeholder text-main p-3 outline-none focus-none bg-transparent w-full"
                            />
                            <div className="absolute top-1/2 -translate-y-1/2" style={{ left: '8px' }}>
                                <SearchIcon />
                            </div>
                        </div>
                    </div>
                    {/* Product Table Header */}
                    <div className="bg-white rounded-md w-full scroll-container" style={{ height: "calc(100% - 240px)", border: isMobile ? 'none' : '1px solid #EBF0F0', overflowY: 'scroll', marginTop: '24px' }}>
                        {
                            !isMobile &&
                            <div className="w-full h-10 gap-x-5" style={{ borderTopLeftRadius: '12px', borderTopRightRadius: '12px', }}>
                                <div className="flex items-center h-full"
                                >
                                    {numberOfKeys.map((val: string) => {
                                        return (
                                            <div
                                                key={val}
                                                className="text-[14px] font-medium leading-[18px] font-inter flex items-center h-full"
                                                style={{
                                                    color: "#6A7878",
                                                    paddingLeft: "12px",
                                                    borderLeft: val === "Return Qty" ? "1px solid #DBE4E4" : 'none',
                                                    borderRight: val === "Return Qty" ? "1px solid #DBE4E4" : 'none',
                                                    backgroundColor: "#EBF0F0",
                                                    width: `calc(100% / ${numberOfKeys.length - 1})`,
                                                }}
                                            >
                                                {language && language?.[val] ? language?.[val] : val}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        }
                        <div className="scroll-container" style={{ height: 'calc(100% - 80px)', overflowY: 'scroll' }}>
                            {formValues?.supplierReturnDetails.map((value: any, index: any) => {
                                // Skip hidden rows instead of filtering, so index stays the full-array position.
                                if (!matchesLineSearch(value)) return null;
                                return (
                                    <>
                                        {isMobile ?
                                            <div
                                                key={value.id}
                                                style={{ border: '1px solid #DBE4E4', padding: '16px', borderRadius: "12px" }}
                                            >
                                                <div
                                                    className="text-[14px] font-medium leading-[18px] font-inter"
                                                    style={{
                                                        color: "#4A5353",
                                                        width: `100%`,
                                                    }}
                                                >
                                                    <p style={{ color: '#6A7878', marginBottom: '4px' }}>
                                                        {language && language?.['SKU']
                                                            ? language?.['SKU']
                                                            : 'SKU'}
                                                    </p>
                                                    {value.product.sku}
                                                </div>
                                                <div className="flex items-center" style={{ margin: '12px 0' }}>
                                                    <div
                                                        className="text-[14px] font-medium leading-[18px] font-inter"
                                                        style={{
                                                            color: "#4A5353",
                                                            width: "50%"
                                                        }}
                                                    >
                                                        <p style={{ color: '#6A7878', marginBottom: '4px' }}>
                                                            {language && language?.['Group']
                                                                ? language?.['Group']
                                                                : 'Group'}
                                                        </p>
                                                        {value.product.productGroup.groupName}
                                                    </div>
                                                    <div
                                                        className="text-[14px] font-medium leading-[18px] font-inter"
                                                        style={{
                                                            color: "#4A5353",
                                                            width: "50%"
                                                        }}
                                                    >
                                                        <p style={{ color: '#6A7878', marginBottom: '4px' }}>
                                                            {language && language?.['Product']
                                                                ? language?.['Product']
                                                                : 'Product'}
                                                        </p>
                                                        {value.product.productName}
                                                    </div>
                                                </div>
                                                <div
                                                    className="text-[14px] font-medium leading-[18px] font-inter "
                                                    style={{
                                                        color: "#4A5353",
                                                        width: `100%`,
                                                    }}
                                                >
                                                    <p style={{ color: '#6A7878', marginBottom: '4px' }}>
                                                        {language && language?.['UOM']
                                                            ? language?.['UOM']
                                                            : 'UOM'}
                                                    </p>
                                                    <DropdownSearch<{ id: string; uomName: string }>
                                                        refKey={`UOMBase-${index}`}
                                                        refs={{
                                                            [`UOMBase-${index}`]: dropdownUOMRef,
                                                        }}
                                                        openStates={{
                                                            [`UOMBase-${index}`]:
                                                                isUOMDropdownOpen[index],
                                                        }}
                                                        open={() => {
                                                            setIsUOMDropdownOpen((prev) => ({
                                                                ...prev,
                                                                [index]: true,
                                                            }));
                                                            setListUOM(value.product.productUOMs?.map((v: any) => ({ id: v.id, productId: v.productId, uomName: v.uom.uomName })))
                                                        }
                                                        }
                                                        close={() =>
                                                            setIsUOMDropdownOpen((prev) => ({
                                                                ...prev,
                                                                [index]: false,
                                                            }))
                                                        }
                                                        data={listUOM}
                                                        labelExtractor={(item) => item.uomName}
                                                        value={searchUOM[value?.productId] !== undefined ? searchUOM[value?.productId] : ""}
                                                        setValue={(val) =>
                                                            setSearchUOM((prev: any) => ({
                                                                ...prev,
                                                                [value.productId]: val,
                                                            }))
                                                        }
                                                        onSelect={(uom) =>
                                                            handleUOMSelect(uom, value.productId)
                                                        }
                                                        onSearch={(value) => {
                                                            handleSearchUOM(value, index)
                                                        }}
                                                        tabIndex={8}
                                                        borderNone={false}
                                                        inItem={true}
                                                    />
                                                </div>
                                                <div className="flex items-center" style={{ margin: '12px 0' }}>
                                                    <div
                                                        className="text-[14px] font-medium leading-[18px] font-inter"
                                                        style={{
                                                            color: "#4A5353",
                                                            width: "50%"
                                                        }}
                                                    >
                                                        <p style={{ color: '#6A7878', marginBottom: '4px' }}>
                                                            {language && language?.['Cost']
                                                                ? language?.['Cost']
                                                                : 'Cost'}
                                                        </p>
                                                        € {value?.cost}
                                                    </div>
                                                    <div
                                                        className="text-[14px] font-medium leading-[18px] font-inter"
                                                        style={{
                                                            color: "#4A5353",
                                                            width: "50%"
                                                        }}
                                                    >
                                                        <p style={{ color: '#6A7878', marginBottom: '4px' }}>
                                                            {language && language?.['Delivery']
                                                                ? language?.['Delivery']
                                                                : 'Delivery'}
                                                        </p>
                                                        {value?.delivered}
                                                    </div>
                                                </div>
                                                <div
                                                    className="text-[14px] font-medium leading-[18px] font-inter "
                                                    style={{
                                                        color: "#4A5353",
                                                        width: `100%`,
                                                    }}
                                                >
                                                    <p style={{ color: '#6A7878', marginBottom: '4px' }}>
                                                        {language && language?.['Return QTY']
                                                            ? language?.['Return QTY']
                                                            : 'Return QTY'}
                                                    </p>
                                                    <input
                                                        type="text"
                                                        name="qtyReturned"
                                                        value={value?.qtyReturned ?? ''}
                                                        onChange={e => {
                                                            handleChangeDetailProduct(index, e, 'qtyReturned');
                                                        }}
                                                        onBlur={e => {
                                                            handleBlurDetailProduct(index, e, 'qtyReturned');
                                                        }}
                                                        onKeyDown={validateOnlyNumbersExpand}
                                                        style={{borderRadius:'0px', padding: "12px", borderLeft: "1px solid #DBE4E4", borderRight: "1px solid #DBE4E4" }}
                                                        className="text-[14px] font-inter placeholder:text-placeholder text-placeholder outline-none focus-none bg-transparent w-full"
                                                    />
                                                </div>
                                                <div
                                                    className="text-[14px] font-medium leading-[18px] font-inter "
                                                    style={{
                                                        color: "#4A5353",
                                                        width: `100%`,
                                                        marginTop: '12px'
                                                    }}
                                                >
                                                    <p style={{ color: '#6A7878', marginBottom: '4px' }}>
                                                        {language && language?.['Line cost']
                                                            ? language?.['Line cost']
                                                            : 'Line cost'}
                                                    </p>
                                                    €   {value?.lineCost.toFixed(2)}
                                                </div>
                                            </div>
                                            :
                                            <div key={value.id} className="w-full h-10 flex items-center bg-white" style={{ borderBottom: '1px solid #EBEBED' }}>
                                                <div
                                                    className="text-[14px] font-medium leading-[18px] font-inter flex items-center h-full"
                                                    style={{
                                                        color: "#4A5353",
                                                        width: `calc(100% / 8)`,
                                                        paddingLeft: "12px"
                                                    }}
                                                >
                                                    {value.product.sku}
                                                </div>
                                                <div
                                                    className="text-[14px] font-medium leading-[18px] font-inter flex items-center h-full"
                                                    style={{
                                                        color: "#4A5353",
                                                        width: `calc(100% / 8)`,
                                                        paddingLeft: "12px"
                                                    }}
                                                >
                                                    {value.product.productGroup.groupName}
                                                </div>
                                                <div
                                                    className="text-[14px] font-medium leading-[18px] font-inter flex items-center h-full"
                                                    style={{
                                                        color: "#4A5353",
                                                        width: `calc(100% / 8)`,
                                                        paddingLeft: "12px"
                                                    }}
                                                >
                                                    {value.product.productName}
                                                </div>
                                                <div
                                                    className="text-[14px] font-medium leading-[18px] font-inter flex items-center h-full"
                                                    style={{
                                                        color: "#4A5353",
                                                        width: `calc(100% / 8)`,
                                                        paddingLeft: "12px"
                                                    }}
                                                >
                                                    <DropdownSearch<{ id: string; uomName: string }>
                                                        refKey={`UOMBase-${index}`}
                                                        refs={{
                                                            [`UOMBase-${index}`]: dropdownUOMRef,
                                                        }}
                                                        openStates={{
                                                            [`UOMBase-${index}`]:
                                                                isUOMDropdownOpen[index],
                                                        }}
                                                        open={() => {
                                                            setIsUOMDropdownOpen((prev) => ({
                                                                ...prev,
                                                                [index]: true,
                                                            }));
                                                            setListUOM(value.product.productUOMs?.map((v: any) => ({ id: v.id, productId: v.productId, uomName: v.uom.uomName })))
                                                        }
                                                        }
                                                        close={() =>
                                                            setIsUOMDropdownOpen((prev) => ({
                                                                ...prev,
                                                                [index]: false,
                                                            }))
                                                        }
                                                        data={listUOM}
                                                        labelExtractor={(item) => item.uomName}
                                                        value={searchUOM[value?.productId] !== undefined ? searchUOM[value?.productId] : ""}
                                                        setValue={(val) =>
                                                            setSearchUOM((prev: any) => ({
                                                                ...prev,
                                                                [value.productId]: val,
                                                            }))
                                                        }
                                                        onSelect={(uom) =>
                                                            handleUOMSelect(uom, value.productId)
                                                        }
                                                        onSearch={(value) => {
                                                            handleSearchUOM(value, index)
                                                        }}
                                                        tabIndex={8}
                                                        borderNone={true}
                                                        inItem={true}
                                                    />
                                                </div>
                                                <div
                                                    className="text-[14px] font-medium leading-[18px] font-inter flex items-center h-full"
                                                    style={{
                                                        color: "#4A5353",
                                                        width: `calc(100% / 8)`,
                                                        paddingLeft: "12px"
                                                    }}
                                                >
                                                    € {value?.cost}
                                                </div>
                                                <div
                                                    className="text-[14px] font-medium leading-[18px] font-inter flex items-center h-full"
                                                    style={{
                                                        color: "#4A5353",
                                                        width: `calc(100% / 8)`,
                                                        paddingLeft: "12px"
                                                    }}
                                                >
                                                    {value?.delivered}
                                                </div>
                                                <div
                                                    className="text-[14px] font-medium leading-[18px] font-inter flex items-center h-full"
                                                    style={{
                                                        color: "#4A5353",
                                                        width: `calc(100% / 8)`,
                                                    }}
                                                >
                                                    <input
                                                        type="text"
                                                        name="qtyReturned"
                                                        value={value?.qtyReturned ?? ''}
                                                        onChange={e => {
                                                            handleChangeDetailProduct(index, e, 'qtyReturned');
                                                        }}
                                                        onBlur={e => {
                                                            handleBlurDetailProduct(index, e, 'qtyReturned');
                                                        }}
                                                        onKeyDown={validateOnlyNumbersExpand}
                                                        style={{ padding: "12px", borderLeft: "1px solid #DBE4E4", borderRight: "1px solid #DBE4E4", borderRadius: '0px !important' }}
                                                        className="text-[14px] font-inter placeholder:text-placeholder text-placeholder outline-none focus-none bg-transparent w-full"
                                                    />
                                                </div>
                                                <div
                                                    className="text-[14px] font-medium leading-[18px] font-inter flex items-center h-full"
                                                    style={{
                                                        color: "#4A5353",
                                                        width: `calc(100% / 8)`,
                                                        paddingLeft: "12px"
                                                    }}
                                                >
                                                    €   {value?.lineCost.toFixed(2)}
                                                </div>
                                            </div>
                                        }
                                    </>
                                );
                            })}
                        </div>
                        {
                            isMobile ?
                                <div onClick={() => { setShowPopupReturn(true) }} className='flex items-center cursor-pointer' style={{marginTop:'16px', height: '40px', padding: '10px 16px', gap: '6px', borderRadius: "12px", backgroundColor: '#EBF0F0' }}>
                                    <div className='flex items-center justify-center' style={{ width: '24px', height: '24px' }}>
                                        <PlusGreenIcon />
                                    </div>
                                    <p className='font-inter' style={{ fontSize: '14px', fontWeight: '500', color: '#0F7679' }}> {language && language?.['Add product'] ? language?.['Add product'] : 'Add product'}</p>
                                </div>
                                :
                                <div onClick={() => { setShowPopupReturn(true) }} className='flex items-center cursor-pointer' style={{ borderTop: '1px solid #DBE4E4', borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px', height: '40px', padding: '10px 16px', gap: '6px' }}>
                                    <div className='flex items-center justify-center' style={{ width: '24px', height: '24px' }}>
                                        <PlusGreenIcon />
                                    </div>
                                    <p className='font-inter' style={{ fontSize: '14px', fontWeight: '500', color: '#0F7679' }}> {language && language?.['Add product'] ? language?.['Add product'] : 'Add product'}</p>
                                </div>
                        }
                    </div>
                    <div className="flex justify-end w-full" style={{ marginTop: '24px' }}>
                        <div
                            style={{
                                width: isMobile ? '100%' : "32%",
                                border: "1px solid #EBF0F0",
                                borderRadius: "12px",
                                overflow: "hidden",
                            }}
                        >
                            {/* SUBTOTAL */}
                            <div
                                className="flex items-center justify-between"
                                style={{
                                    backgroundColor: "white",
                                    height: "40px",
                                    padding: "0px 16px",
                                }}
                            >
                                <p
                                    style={{ fontSize: '14px' }}
                                    className="text-black font-inter font-medium "
                                >
                                    {language?.["Subtotal"] ?? "Subtotal"}
                                </p>
                                <p
                                    style={{ fontSize: '14px', color: '#4A5353' }}
                                    className="text-black font-inter font-medium"
                                >
                                    {(
                                        (formValues?.supplierReturnDetails ?? []).reduce((acc: number, val: any) => {
                                            const lineCost = Number(val?.lineCost) || 0;
                                            const taxRate = Number(val?.product?.productPrices[0]?.tax?.primaryRate) || 0;
                                            return acc + lineCost / (1 + taxRate / 100);
                                        }, 0)
                                    ).toFixed(2)}
                                    €
                                </p>
                            </div>

                            {/* TAX */}
                            <div
                                className="flex items-center justify-between"
                                style={{
                                    backgroundColor: "white",
                                    height: "40px",
                                    padding: "0px 16px",
                                }}
                            >
                                <p
                                    style={{ fontSize: '14px' }}
                                    className="text-black font-inter font-medium"
                                >
                                    {language?.["TAX"] ?? "TAX"}
                                </p>
                                <p
                                    style={{ fontSize: '14px', color: '#4A5353' }}
                                    className="text-black font-inter font-medium"
                                >
                                    {(() => {
                                        const totalWithTax = (formValues?.supplierReturnDetails ?? []).reduce(
                                            (acc: number, val: any) => acc + (Number(val?.lineCost) || 0),
                                            0
                                        );
                                        const totalWithoutTax = (formValues?.supplierReturnDetails ?? []).reduce(
                                            (acc: number, val: any) => {
                                                const lineCost = Number(val?.lineCost) || 0;
                                                const taxRate = Number(val?.product?.productPrices[0]?.tax?.primaryRate) || 0;
                                                return acc + lineCost / (1 + taxRate / 100);
                                            },
                                            0
                                        );
                                        return (totalWithTax - totalWithoutTax).toFixed(2);
                                    })()}
                                    €
                                </p>
                            </div>

                            {/* TOTAL */}
                            <div
                                className="flex items-center justify-between"
                                style={{
                                    backgroundColor: "#EBF0F0",
                                    height: "50px",
                                    padding: "0px 16px",
                                }}
                            >
                                <p
                                    style={{ fontSize: '16px', fontWeight: 500, color: "#000000" }}
                                    className="text-black font-inter font-medium"
                                >
                                    {language?.["TOTAL"] ?? "TOTAL"}
                                </p>
                                <p
                                    style={{ fontSize: '16px', fontWeight: 500, color: "#4A5353" }}
                                    className="text-black font-inter font-medium"
                                >
                                    {(
                                        (formValues?.supplierReturnDetails ?? []).reduce(
                                            (acc: number, val: any) => acc + (Number(val?.lineCost) || 0),
                                            0
                                        )
                                    ).toFixed(2)}
                                    €
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="w-full flex items-center justify-end shadow_button relative"
                style={{ gap: "12px", paddingTop: "24px", }}
            >
                <div className="absolute" style={{ left: "-24px", top: 0, height: "1px", backgroundColor: "#DBE4E4", width: isMobile ? 'calc(100vw + 32px)' : "calc(-256px + 48px + 100vw)" }}></div>
                <div
                    onClick={() => {
                        webNavigate('/' + preLanguage + '/supplierReturn');
                    }}
                    style={{
                        padding: '10px 24px',
                        borderRadius: '30px',
                        color: '#222525',
                        fontSize: '14px',
                        fontWeight: '500',
                        border: '1px solid #C9D7D8',
                    }}
                    className="font-inter cursor-pointer"
                >
                    {language && language?.['Cancel'] ? language?.['Cancel'] : 'Cancel'}
                </div>
                {
                    formValues?.statusId === 3 || formValues?.statusId === 4 ? null : (
                        <div style={{
                            padding: '10px 24px',
                            borderRadius: '30px',
                            color: '#FFFFFF',
                            fontSize: '14px',
                            fontWeight: '500',
                            backgroundColor: '#0F7679',
                        }}
                            className="font-inter cursor-pointer"
                            onClick={(e) => { handleSubmit(e) }}
                        >
                            <p className="text-[14px] leading-[22px] font-inter">{language && language?.["Confirm"] ? language?.["Confirm"] : "Confirm"}</p>
                        </div>
                    )
                }
            </div>
            <ProductSelectionSupplierModal
                showPopup={showPopupReturn}
                onClose={handleCancelAddProductReturn}
                products={listProductsReturn}
                filter={filterReturn}
                searchUOMBase={searchUOMReturnForModal}
                onFilterChange={setFilterReturn}
                onSearchSubmit={handleSubmitSearchProductReturn}
                onSelectProduct={handleSelectProductReturn}
                onSelectUOM={handleSelectUOM}
                onCancel={handleCancelAddProductReturn}
                onSave={handleAddProductReturn}
                loading={loading.productReturn}
                language={language}
                scrollRef={scrollRefReturn}
                loaderRef={setLoaderRefReturn}
                SearchIcon={SearchIcon}
                CloseIcon={CloseIcon}
                WhiteCheckIcon={WhiteCheckIcon}
            />
            <PopupLocation
                show={showPopup}
                title="Delivery"
                desc={popupDesc}
                onClose={handleClosePopup}
                onOpen={handleOpenPopup}
            />
        </>
    );
};
export default SupplierReturnDetails;
